import * as React from "react"
import { Appearance, Platform, TouchableOpacity } from "react-native"
import { Text } from "../text/text"
import { viewPresets, textPresets } from "./button.presets"
import { ButtonProps } from "./button.props"
import { useEffect, useRef } from "react"

/**
 * For your text displaying needs.
 *
 * This component is a HOC over the built-in React Native one.
 */
export function Button(props: ButtonProps) {
  // grab the props
  const {
    preset = "primary",
    colorScheme = Appearance.getColorScheme(),
    tx,
    text,
    textPreset,
    textColorScheme = colorScheme || Appearance.getColorScheme(),
    textColor,
    style: styleOverride,
    textStyle: textStyleOverride,
    children,
    disabled,
    loading,
    isTruncated = false,
    ...rest
  } = props

  const buttonRef = useRef<TouchableOpacity>(null)

  const viewStyle = viewPresets(colorScheme)[preset] || viewPresets(colorScheme).primary
  const viewStyles = [viewStyle, disabled && preset !== "link" && viewPresets(colorScheme).disabled, loading && preset !== "link" && viewPresets(colorScheme).loading, styleOverride]
  const textStyle = textPresets(colorScheme)[preset] || textPresets(colorScheme).primary
  const textStyles = [textStyle, textStyleOverride, loading && preset === "link" && textPresets(colorScheme).linkLoading]

  useEffect(() => {
    if (buttonRef.current && Platform.OS === 'web')
      buttonRef.current.setNativeProps({ tabindex: -1 });
  }, [])

  return (
    <TouchableOpacity testID="jala:id/button" ref={buttonRef} style={viewStyles} disabled={disabled || loading} {...rest}>
      {children || <Text tx={tx} text={text} preset={textPreset || "title3"} colorScheme={textColorScheme} color={textColor} style={textStyles} isTruncated={isTruncated} />}
    </TouchableOpacity>
  )
}
